import { Keyboard, KeyboardLanguagesMap, KeyboardMap, KeyboardMapKey } from './types';

interface InitKeyboard {
  fullWidth: number;
  fullHeight: number;
  firstFocusIndexY: number;
  firstFocusIndexX: number;
}
export const initKeyboard = (keyboardMap: KeyboardMap): InitKeyboard => {
  if (!keyboardMap.length) {
    throw new Error('Keyboard is not defined');
  }
  const fullWidth = keyboardMap[0].reduce((prev: number, current: KeyboardMapKey) => prev + current.width, 0);
  const fullHeight = keyboardMap.length;
  const firstFocusIndexX = Math.floor((fullWidth - 1) / 2);
  const firstFocusIndexY = Math.floor((fullHeight - 1) / 2);

  return { fullWidth, fullHeight, firstFocusIndexY, firstFocusIndexX };
};

export const setupKeyboard = (keyboardMap: KeyboardMap): Keyboard | undefined => {
  return keyboardMap.map((keyMap) =>
    keyMap.map((key) => ({
      value: key.lower[0],
      width: key.width,
      lower: key.lower[0],
      upper: key.upper[0],
      diacritic: {
        lower: key.lower.slice(1),
        upper: key.upper.slice(1),
      },
    })),
  );
};

export const removeDiacriticFromKeyboard = (keyboard: Keyboard, isShift = false): Keyboard => {
  const keyCase = isShift ? 'upper' : 'lower';
  keyboard.forEach((keyRow) =>
    keyRow.forEach((key) => {
      key.diacriticForValue = undefined;
      key.value = Array.isArray(key[keyCase]) ? key[keyCase][0] : key[keyCase];
    }),
  );
  return keyboard;
};

export const addDiacriticToKeyboard = (
  keyboard: Keyboard,
  diacriticForValue: string,
  diacriticKeys: string[],
  y: number,
  x: number,
): Keyboard => {
  const leftSlip = Math.max(0, diacriticKeys.length + x - keyboard[y].length);
  const startY = y - 1;
  const startX = x - leftSlip;
  for (let i = 0; i < diacriticKeys.length; i++) {
    keyboard[startY][startX + i].value = diacriticKeys[i];
    keyboard[startY][startX + i].diacriticForValue = diacriticForValue;
  }
  return keyboard;
};

export const changeKeyCase = (keyboard: Keyboard, isShift: boolean): Keyboard => {
  const keyCase = isShift ? 'upper' : 'lower';
  keyboard.forEach((keyRow) => {
    keyRow.forEach((key) => {
      key.value = key[keyCase];
    });
  });
  return keyboard;
};

export const fetchLanguages = async (languageUrlArr: [string, string][]): Promise<KeyboardLanguagesMap> => {
  return Object.fromEntries(
    await Promise.all(
      languageUrlArr.map(([language, url]) =>
        fetch(url)
          .then((response) => response.json())
          .then((data) => [language, data]),
      ),
    ),
  );
};
